import axios from "axios";

export const BaseUrl = 'https://rqm.ai/api' //'http://127.0.0.1:5000/api'
//'https://rqm.ai/api'

export const PostRequest = async (url, PostData, token = null) => {

    console.log(`${BaseUrl}/${url}`);

    try {
        const { data } = await axios.post(`${BaseUrl}/${url}`, PostData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(data);

        return data;
    } catch (err) {
        console.log(err);

        return err.response;
    }
};

export const PostRequestWithSendCookies = async (url, PostData, token = null) => {

    console.log(`${BaseUrl}/${url}`);

    try {
        const { data } = await axios.post(`${BaseUrl}/${url}`, PostData, {
            headers: {
                Authorization: `Bearer ${token}`,
                withCredentials: true,
            },

        });

        // console.log(data);

        return data;
    } catch (err) {
        console.log(err);

        return err.response;
    }
};

export const GetRequest = async (url, token) => {
    try {
        const { data } = await axios.get(`${BaseUrl}/${url}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return data;
    } catch (err) {
        return err.response.data.Message;
    }
};

export const DeleteRequest = async (url, token) => {
    try {
        const { data } = await axios.delete(`${BaseUrl}/${url}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return data;
    } catch (err) {
        return err.response.data.Message;
    }
};

export const PatchRequest = async (url, token = null) => {
    // console.log(token);

    try {
        const { data } = await axios.patch(
            `${BaseUrl}${url}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );


        return data;
    } catch (err) {
        console.log(err);

        return err.response.data.Message;
    }
};
